import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    status: { enabled: false, optOut: false, connected: false, loaded: false },
};

const calendarSlice = createSlice({
    name: "calendar",
    initialState,
    reducers: {
        getCalendarStatus() {},
        setCalendarStatus(state, action) {
            state.status = { ...state.status, ...action.payload, loaded: true };
        },
    },
});

export const { getCalendarStatus, setCalendarStatus } = calendarSlice.actions;

export default calendarSlice.reducer;
